<div>
  @if (form(); as authForm) {
    @if (connectedIntegrationOnly()) {
      <glxy-form-field>
        <mat-checkbox
          [checked]="authForm.controls.type.value === 'connectedIntegration'"
          (change)="toggleConnectedIntegration($event.checked)"
        >
          {{ 'AI_ASSISTANT.FUNCTIONS.AUTH_STRATEGY.USE_CONNECTED_INTEGRATION' | translate }}
        </mat-checkbox>
      </glxy-form-field>

      @if (authForm.controls.type.value === 'connectedIntegration') {
        <glxy-form-field>
          <glxy-label>
            {{ 'AI_ASSISTANT.FUNCTIONS.AUTH_STRATEGY.INTEGRATION_TYPE.LABEL' | translate }}
            <mat-icon
              class="info-icon"
              [glxyTooltip]="'AI_ASSISTANT.FUNCTIONS.AUTH_STRATEGY.INTEGRATION_TYPE.HINT' | translate"
            >
              info_outline
            </mat-icon>
          </glxy-label>
          <mat-select [formControl]="authForm.controls.integrationType">
            @for (integration of integrationOptions(); track integration.integrationType) {
              <mat-option [value]="integration.integrationType">
                {{ integration.displayName }}
              </mat-option>
            }
          </mat-select>
          @if (authForm.hasError('connectionRequired') && authForm.touched) {
            <glxy-error>
              {{ 'AI_ASSISTANT.FUNCTIONS.AUTH_STRATEGY.INTEGRATION_REQUIRED' | translate }}
            </glxy-error>
          }
        </glxy-form-field>
      }
    } @else {
      <glxy-form-field>
        <glxy-label>{{ 'AI_ASSISTANT.FUNCTIONS.AUTH_STRATEGY.LABEL' | translate }}</glxy-label>
        <mat-select (selectionChange)="typeChange($event.value)" [formControl]="authForm.controls.type">
          <mat-option value="unspecified">
            {{ 'AI_ASSISTANT.FUNCTIONS.AUTH_STRATEGY.NONE' | translate }}
          </mat-option>
          <mat-option value="platformManaged">
            {{ 'AI_ASSISTANT.FUNCTIONS.AUTH_STRATEGY.VENDASTA_AUTH' | translate }}
          </mat-option>
          <mat-option value="impersonation">
            {{ 'AI_ASSISTANT.FUNCTIONS.AUTH_STRATEGY.IMPERSONATION' | translate }}
          </mat-option>
          <mat-option value="impersonationWithPlatformManagedFallback">
            {{ 'AI_ASSISTANT.FUNCTIONS.AUTH_STRATEGY.IMPERSONATION_WITH_PLATFORM_MANAGED_FALLBACK' | translate }}
          </mat-option>
          <mat-option value="connectedIntegration">
            {{ 'AI_ASSISTANT.FUNCTIONS.AUTH_STRATEGY.CONNECTED_INTEGRATION' | translate }}
          </mat-option>
        </mat-select>
      </glxy-form-field>

      @if (
        authForm.controls.type.value === 'platformManaged' ||
        authForm.controls.type.value === 'impersonation' ||
        authForm.controls.type.value === 'impersonationWithPlatformManagedFallback'
      ) {
        @if (showScopes()) {
          @if (scopeOptions$ | async; as scopeOptions) {
            <glxy-form-field>
              <glxy-label>{{ 'AI_ASSISTANT.FUNCTIONS.AUTH_STRATEGY.REQUIRED_SCOPES' | translate }}</glxy-label>
              <mat-select [formControl]="authForm.controls.requiredScopes" multiple>
                @for (scopeOption of scopeOptions; track scopeOption) {
                  <mat-option [value]="scopeOption">
                    {{ scopeOption }}
                  </mat-option>
                }
              </mat-select>
            </glxy-form-field>
          } @else {
            <div>{{ 'AI_ASSISTANT.FUNCTIONS.AUTH_STRATEGY.LOADING_SCOPES' | translate }}</div>
          }
        }
      }

      @if (authForm.controls.type.value === 'connectedIntegration') {
        <glxy-form-field>
          <glxy-label>
            {{ 'AI_ASSISTANT.FUNCTIONS.AUTH_STRATEGY.INTEGRATION_TYPE.LABEL' | translate }}
            <mat-icon
              class="info-icon"
              [glxyTooltip]="'AI_ASSISTANT.FUNCTIONS.AUTH_STRATEGY.INTEGRATION_TYPE.HINT' | translate"
            >
              info_outline
            </mat-icon>
          </glxy-label>
          <mat-select [formControl]="authForm.controls.integrationType">
            <mat-option [value]="''">
              {{ 'AI_ASSISTANT.FUNCTIONS.AUTH_STRATEGY.NONE' | translate }}
            </mat-option>
            @for (integration of integrationOptions(); track integration.integrationType) {
              <mat-option [value]="integration.integrationType">
                {{ integration.displayName }}
              </mat-option>
            }
          </mat-select>
          @if (authForm.hasError('connectionRequired') && authForm.touched) {
            <glxy-error>
              {{ 'AI_ASSISTANT.FUNCTIONS.AUTH_STRATEGY.CONNECTED_INTEGRATION_REQUIRED' | translate }}
            </glxy-error>
          }
        </glxy-form-field>

        <glxy-form-field>
          <glxy-label>
            {{ 'AI_ASSISTANT.FUNCTIONS.AUTH_STRATEGY.CONNECTION_ID.LABEL' | translate }}
            <mat-icon
              class="info-icon"
              [glxyTooltip]="'AI_ASSISTANT.FUNCTIONS.AUTH_STRATEGY.CONNECTION_ID.HINT' | translate"
            >
              info_outline
            </mat-icon>
          </glxy-label>
          <input type="text" [formControl]="authForm.controls.connectedIntegrationId" />
        </glxy-form-field>
      }
    }
  }
</div>
